import React, { useState, useCallback, useEffect } from "react";
import { useSelector } from "react-redux";
import { clientHistory } from "../../utils/enum/enums";
import { createCustomerLogService } from "../../services/logs/services";
import { getDepositTypesService } from "../../services/deposit/services";
import { useNotifications } from "../../context/Notifications";
import { useTranslator } from "../../context/translator";
import HistoryModalHeader from "../historyModalHeader/HistoryModalHeader";
import HistoryForm from "../historyForm/HistoryForm";
import { useGetCompanyQuery, useGetUserByIdQuery } from "store/api/apiSlice";

const HistoryModal = ({ customer }) => {
  const { user } = useSelector((state) => state.user);

  const { data: userProfile, isLoading: userLoading } = useGetUserByIdQuery(
    user.id,
    {
      skip: !user?.id,
      pollingInterval: 60000,
      refetchOnFocus: true,
      refetchOnReconnect: true,
    },
  );

  const { data: company, isLoading: companyLoading } = useGetCompanyQuery(
    userProfile?.user?.companyId,
    {
      skip: !userProfile?.user?.companyId,
    },
  );
  const { addNotification } = useNotifications();
  const { translate } = useTranslator();
  const [companyAllow, setCompanyAllow] = useState([]);
  const [modalOpen, setModalOpen] = useState(false);
  const [isLoading, setIsLoading] = useState(false);
  const [type, setType] = useState(clientHistory.COMMENT);
  const [depositTypes, setDepositTypes] = useState([]);

  const toggleModal = () => setModalOpen((prev) => !prev);

  const getDepositTypesCall = useCallback(async () => {
    const data = await getDepositTypesService({
      companyId: company?._id,
    });
    setDepositTypes(data?.deposits ?? []);
  }, [company?._id]);

  useEffect(() => {
    getDepositTypesCall();
  }, [getDepositTypesCall]);

  useEffect(() => {
    if (company && company?.allow) {
      setCompanyAllow({ ...company?.allow });
    }
  }, [company]);

  const handleSubmit = async (formData) => {
    setIsLoading(true);
    const response = await createCustomerLogService({
      accountNumber: customer?.accountNumber,
      customerId: customer?._id,
      companyId: company?._id,
      agent: user.ext,
      ...formData,
    });

    if (response?.logs?.acknowledged) {
      addNotification({
        id: Date.now(),
        message: translate("log-created"),
        kind: "success",
      });
      toggleModal();
    } else {
      addNotification({
        id: Date.now(),
        message: translate("error-creating-log"),
        kind: "danger",
      });
    }
    setIsLoading(false);
  };

  if (userLoading || companyLoading) return null;

  return (
    <>
      <button
        className="text-white bg-blue-600 hover:bg-blue-700 focus:ring-4 focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5"
        onClick={toggleModal}
        type="button"
      >
        {translate("create-comm-log")}
      </button>

      {modalOpen && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 overflow-y-auto">
          <div className="relative w-full max-w-2xl p-4">
            <div className="bg-white dark:bg-gray-700 rounded-lg shadow">
              <HistoryModalHeader
                title={translate("new-comm-log")}
                onClose={toggleModal}
                disabled={isLoading}
              />
              <HistoryForm
                type={type}
                setType={setType}
                depositTypes={depositTypes}
                onSubmit={handleSubmit}
                onCancel={toggleModal}
                isLoading={isLoading}
                allow={companyAllow}
                translate={translate}
              />
            </div>
          </div>
        </div>
      )}
    </>
  );
};

export default HistoryModal;
